import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, first } from 'rxjs/operators';

import { AuthService, Course, SharedService, User } from '@app/core';
import { CourseService } from '@app/services';
import { PmdModal, PmdSidebar } from '@shared/propeller';
import { ISidebarMenu } from './sidebar-menu.interface';
import { SidebarService } from './sidebar.service';
import { GameService, MarketService } from '@games/services';
import { GameService as GlobalGameService } from '@app/services';
import { Game } from '@courses/entities';
import { AppGlobals } from '@app/app.global';
import { SimulationService } from '@games/services';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [SidebarService],
  standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild('dashBoardListEl', { static: true }) dashBoardListEl: ElementRef;
  @ViewChild('courseListEl', { static: true }) courseListEl: ElementRef;
  @ViewChild('gameListEl', { static: true }) gameListEl: ElementRef;
  @ViewChild('helpListEl', { static: true }) helpListEl: ElementRef;

  @ViewChild('simulateGameModal') simulateGameModal: PmdModal;
  @ViewChild('rollbackGameModal') rollbackGameModal: PmdModal;
  @ViewChild(PmdSidebar) leftSidebar: { toggleSideBar: () => void };
  @ViewChild('childSidebar') firstSidebar: PmdSidebar;
  @ViewChild('grandChildSidebar') secondSidebar: PmdSidebar;

  sidebarOverlay = false;
  loggedinUser: User;
  courseSearchText: string = '';
  coursesCount: number = 0;
  gamesCount: number = 0;
  courseRequestCount: number = 0;
  marketId: number;
  entityId: number;
  selectedGameMenu: ISidebarMenu[];
  selectedFirstMenu: ISidebarMenu[];
  mainSidebarMenus: ISidebarMenu[];
  firstSidebarMenus: ISidebarMenu[];
  gameListSidebarMenus: ISidebarMenu[];
  secondSidebarMenus: ISidebarMenu[];
  helpSidebarMenu: ISidebarMenu[];

  courseId: number;
  game: Game;
  simulatedPeriods: number[] = [];
  rollbackForm: UntypedFormGroup;
  isRollbackSubmitAttempted: boolean = false;
  private simulationSubscription: Subscription | null = null;

  constructor(
    private courseService: CourseService,
    private formBuilder: UntypedFormBuilder,
    private gameService: GameService,
    private globalGameService: GlobalGameService,
    private authService: AuthService,
    private router: Router,
    private sidebarService: SidebarService,
    public sharedService: SharedService,
    private marketService: MarketService,
    public appGlobals: AppGlobals,
    private simulationService: SimulationService
  ) {
    this.loggedinUser = this.authService.user;
    this.sharedService.sideBarToggle.subscribe(() => {
      this.leftSidebar.toggleSideBar();
      this.sidebarOverlay = true;
    });
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe((route: NavigationEnd) => {
        if (/^\/course\/\d+\/game\/\d+($|\?|\/.+)/.test(route.urlAfterRedirects)) {
          const firstMenuIds = route.urlAfterRedirects.match(/\d+/g);

          if (this.firstSidebar?.isOpen) {
            this.firstSidebar.toggleSideBar();
          }

          if (firstMenuIds && firstMenuIds.filter(menuId => !isNaN(+menuId)).length > 1) {
            const courseId = +firstMenuIds[0],
              gameId = +firstMenuIds[1];

            this.marketService.getMarkets(courseId, gameId, { page: '1' }, true).subscribe(
              (res: any) => {
                this.marketId = res.results[0].id;
                this.entityId = res.results[0].entities[0].id;
              },
              (error: any) => {
                this.sharedService.errorAlert(error);
              }
            );
            this.courseId = +firstMenuIds[0];
            this.courseService
              .getCourse(courseId)
              .pipe(first())
              .subscribe(
                (course: Course) => {
                  if (course.locale) {
                    this.sharedService.changeLanguage(
                      this.loggedinUser?.configuredLanguage,
                      course.locale
                    );
                  }

                  this.selectedFirstMenu = this.sidebarService.secondSidebarMenus
                    .filter(menu => {
                      if (menu.name === 'Textbook') {
                        return !!course.textbook && course.userCourseStatus === 1;
                      }
                      return true;
                    })
                    .map(menu => {
                      if (menu.path) {
                        menu.path.splice(1, 1, course.id);
                      }
                      if (menu.onClick) {
                        menu.onClick = () =>
                          this.sidebarService.textbookSubject.next(
                            course.textbook ? course.textbook.entryUrl : ''
                          );
                      }
                      switch (menu.name) {
                        case 'Summary':
                          menu.isDisabled = false;
                          break;
                        case 'Users':
                          menu.isDisabled = false;
                          break;
                        case 'Games':
                          menu.isDisabled = false;
                          break;
                        case 'Quizzes':
                          menu.isDisabled = true;
                          break;
                      }
                      return menu;
                    });
                  this.mainSidebarMenus = this.sidebarService.mainSidebarMenus;
                  // this.getGames(course.id);
                },
                (error: any) => {
                  console.log(error);
                  this.sharedService.errorAlert(error);
                  this.router.navigate(['/course', courseId, 'game']);
                }
              );
            this.gameService
              .getGame(courseId, gameId)
              .pipe(first())
              .subscribe(
                (game: Game) => {
                  this.game = game;
                  this.simulationService.setCurrentGame(game);
                  this.simulatedPeriods = [...Array(game.period).keys()];
                  this.gameListSidebarMenus?.forEach(menuItem => {
                    menuItem.visible = menuItem.id === gameId;
                  });
                  if (this.game.isCompetitive && this.loggedinUser.isPlayer) {
                    this.selectedGameMenu = this.sidebarService.gamePlayerSidebarMenus.map(menu => {
                      if (menu.path) {
                        menu.path.splice(1, 3, courseId, 'game', game.id);
                      }
                      if (menu.name === 'Decisions') {
                        menu.path.splice(
                          1,
                          5,
                          courseId,
                          'game',
                          game.id,
                          this.marketId,
                          this.entityId
                        );
                      }
                      menu.isDisabled = false;
                      return menu;
                    });
                  } else {
                    this.selectedGameMenu = this.sidebarService.gameSidebarMenus.map(menu => {
                      if (menu.path) {
                        menu.path.splice(1, 3, courseId, 'game', game.id);
                      }
                      if (menu.name === 'Decisions') {
                        menu.path.splice(
                          1,
                          5,
                          courseId,
                          'game',
                          game.id,
                          this.marketId,
                          this.entityId
                        );
                      }
                      menu.isDisabled = false;
                      return menu;
                    });
                  }
                  this.sidebarService.simulateGameModalSubject.subscribe(show => {
                    if (show) {
                      if (!this.loggedinUser.isPlayer || this.game.isAutosim) {
                        this.simulateGameModal.show();
                      } else {
                        this.sharedService.errorAlert(
                          "You don't have access to simulate this game!"
                        );
                      }
                    } else {
                      this.simulateGameModal.hide();
                    }
                  });
                  this.sidebarService.rollbackGameModalSubject.subscribe(show => {
                    if (show) {
                      if (this.loggedinUser.isPlayer && !this.game.isAutosim) {
                        this.sharedService.errorAlert(
                          "You don't have access to rollback this game!"
                        );
                      } else if (this.game.period <= 0) {
                        this.sharedService.errorAlert('The game cannot be rollbacked!');
                      } else {
                        this.f.period.setValue(this.game.period - 1);
                        this.f.erase.setValue(false);
                        this.rollbackGameModal.show();
                      }
                    } else {
                      this.rollbackGameModal.hide();
                    }
                  });
                },
                (error: any) => {
                  console.log(error);
                  this.sharedService.errorAlert(error);
                  this.router.navigate(['/course', courseId, 'game']);
                }
              );
          }
        } else if (/^\/course\/\d+($|\/.+)/.test(route.urlAfterRedirects)) {
          const firstMenuId = +route.urlAfterRedirects.match(/\d+/)?.[0];

          if (this.firstSidebar?.isOpen) {
            this.firstSidebar.toggleSideBar();
          }

          if (firstMenuId && !isNaN(firstMenuId)) {
            this.courseId = firstMenuId;
            this.game = null;
            this.courseService
              .getCourse(firstMenuId)
              .pipe(first())
              .subscribe(
                (course: Course) => {
                  if (course.locale) {
                    this.sharedService.changeLanguage(
                      this.loggedinUser?.configuredLanguage,
                      course.locale
                    );
                  }

                  this.selectedFirstMenu = this.sidebarService.secondSidebarMenus
                    .filter(menu => {
                      if (menu.name === 'Textbook') {
                        return !!course.textbook && course.userCourseStatus === 1;
                      }
                      return true;
                    })
                    .map(menu => {
                      if (menu.path) {
                        menu.path.splice(1, 1, course.id);
                      }
                      if (menu.onClick) {
                        menu.onClick = () =>
                          this.sidebarService.textbookSubject.next(
                            course.textbook ? course.textbook.entryUrl : ''
                          );
                      }
                      switch (menu.name) {
                        case 'Summary':
                          menu.isDisabled = false;
                          break;
                        case 'Users':
                          menu.isDisabled = false;
                          break;
                        case 'Games':
                          menu.isDisabled = false;
                          break;
                        case 'Quizzes':
                          menu.isDisabled = true;
                          break;
                      }
                      return menu;
                    });
                  this.selectedGameMenu = this.sidebarService.gameSidebarMenus.map(menu => {
                    menu.isDisabled = true;
                    return menu;
                  });
                  this.mainSidebarMenus = this.sidebarService.mainSidebarMenus;
                  this.getGames(course.id);
                },
                (error: any) => {
                  console.log(error);
                  this.sharedService.errorAlert(error);
                  this.router.navigate(['course/list']);
                }
              );
          }
        } else {
          this.courseId = null;
          this.game = null;
          this.sharedService.changeLanguage(this.loggedinUser?.configuredLanguage);
          this.selectedFirstMenu = this.sidebarService.secondSidebarMenus
            .filter(menu => menu.name !== 'Textbook')
            .map(menu => {
              menu.isDisabled = true;
              return menu;
            });
          this.selectedGameMenu = this.sidebarService.gameSidebarMenus.map(menu => {
            menu.isDisabled = true;
            return menu;
          });
          this.mainSidebarMenus = this.sidebarService.mainSidebarMenus;
        }

        this.openSubMenuOnUrl(route.urlAfterRedirects);
      });
  }

  ngOnInit() {
    this.firstSidebarMenus = this.sidebarService.firstSidebarMenus;
    this.secondSidebarMenus = this.sidebarService.secondSidebarMenus
      .filter(menu => menu.name !== 'Textbook')
      .map(menu => {
        menu.isDisabled = true;
        return menu;
      });
    this.selectedGameMenu = this.sidebarService.gameSidebarMenus.map(menu => {
      menu.isDisabled = true;
      return menu;
    });
    this.sidebarService.textbookSubject.subscribe(textbook => {
      if (textbook) {
        this.sharedService.openFile(textbook);
      } else {
        this.sharedService.errorAlert("The course don't have any textbook!");
      }
    });
    this.helpSidebarMenu = this.sidebarService.helpSidebarMenus;
    this.getCourses();
    this.getCourseRequests();
    this.createRollbackForm();

    // Subscribe to simulation state changes
    this.simulationSubscription = this.simulationService.simulationState$.subscribe(state => {
      if (state.currentGame && this.game && state.currentGame.id === this.game.id) {
        this.game = state.currentGame;
        this.simulatedPeriods = [...Array(state.currentGame.period).keys()];
      }
    });
  }

  get f() {
    return this.rollbackForm.controls;
  }

  openSubMenuOnUrl(url: string) {
    const match = url.match(/^\/([^\/]+)/);
    const firstSegment = match ? match[1] : null;
    let activateMenu;

    switch (firstSegment) {
      case 'profile':
      case 'user':
      case 'heatmap':
        activateMenu = this.dashBoardListEl;
        break;
      case 'course':
        if (url.includes('list') && url.includes('game')) {
          activateMenu = this.courseListEl;
        } else if (url.includes('list')) {
          activateMenu = this.dashBoardListEl;
        } else if (url.includes('game')) {
          activateMenu = this.gameListEl;
        } else {
          activateMenu = this.courseListEl;
        }
        break;
      default:
        activateMenu = this.helpListEl;
        break;
    }

    [this.dashBoardListEl, this.courseListEl, this.gameListEl, this.helpListEl].forEach(ref => {
      ref.nativeElement.classList.remove('showMenu');
    });

    this.showSubmenu(activateMenu.nativeElement);
  }

  simulateGame() {
    this.simulateGameModal.hide();
    this.simulationService.startSimulation(this.courseId, this.game.id).subscribe({
      next: res => {
        // Only navigate if we're not already on the game detail page
        const currentUrl = this.router.url;
        const targetUrl = `/course/${this.courseId}/game/${this.game.id}`;
        if (!currentUrl.includes(targetUrl)) {
          this.router.navigate(['/course', this.courseId, 'game', this.game.id]);
        }
        console.log('Simulation started:', res);
      },
      error: error => {
        console.log('Simulation failed:', error);
      },
    });
  }

  rollbackGame() {
    this.isRollbackSubmitAttempted = true;

    if (this.rollbackForm.invalid) {
      this.isRollbackSubmitAttempted = false;
      this.sharedService.errorAlert('Please check the invalid inputs.');
      return;
    }

    const courseId = this.courseId,
      gameId = this.game.id,
      selectedPeriod = this.f.period.value,
      erase = this.f.erase.value;

    this.rollbackGameModal.hide();
    this.gameService.rollback(courseId, gameId, selectedPeriod, erase).subscribe(
      (game: Game) => {
        this.game = game;
        this.simulatedPeriods = [...Array(game.period).keys()];
        this.f.period.setValue(game.period - 1);
        this.f.erase.setValue(false);
        this.rollbackForm.markAsPristine();
        this.rollbackForm.markAsUntouched();
        this.isRollbackSubmitAttempted = false;
        this.sharedService.successAlert('The game is rollbacked successfully!');
      },
      (error: any) => {
        console.log(error);
        this.isRollbackSubmitAttempted = false;
        this.sharedService.errorAlert(error);
      }
    );
  }

  createRollbackForm() {
    this.rollbackForm = this.formBuilder.group({
      period: ['', Validators.required],
      erase: [false],
    });
  }

  getCourseSidebarMenu(course: Course): ISidebarMenu {
    return {
      id: course.id,
      name: course.name,
      path: ['/course', course.id],
      ariaLabel: 'Press enter to open the ' + course.name + ' menu',
      icon: course.icon,
      altIcon: course.courseCode.substring(0, 2),
      haveSubMenu: course.usercourse.status === 1,
      isDisabled: false,
      textbook: course.textbook,
    };
  }

  getGameSidebarMenu(courseId: number, game: Game): ISidebarMenu {
    return {
      id: game.id,
      name: game.name,
      path: ['/course', courseId, 'game', game.id],
      ariaLabel: 'Press enter to open the ' + game.name + ' menu',
      haveSubMenu: false,
      isDisabled: false,
      icon: game.icon,
    };
  }

  getCourses(moreCourse: boolean = false) {
    const filters: any = {};

    if (this.courseSearchText) {
      filters.name = this.courseSearchText;
    }

    this.courseService.getCourses(filters).subscribe((data: any) => {
      const menus = data.results.map((course: Course) => this.getCourseSidebarMenu(course));
      this.firstSidebarMenus = moreCourse ? [...this.firstSidebarMenus, ...menus] : menus;
      this.coursesCount = data.count;
    });
  }

  getGames(courseId) {
    this.globalGameService.getGames(courseId, {}).subscribe((data: any) => {
      this.gameListSidebarMenus = data.results.map((game: Game) =>
        this.getGameSidebarMenu(courseId, game)
      );
      this.gamesCount = data.count;
    });
  }

  getCourseRequests() {
    if (this.loggedinUser.isPlayer) {
      this.courseService.getInvitations().subscribe((data: any) => {
        this.courseRequestCount = data.count;
      });
    } else {
      this.courseService.getRequests().subscribe((data: any) => {
        this.courseRequestCount = data.count;
      });
    }
  }

  onSearchChanges() {
    this.getCourses();
  }

  logout() {
    this.authService.logout();
  }

  showSubmenu(itemEl: HTMLElement) {
    itemEl.classList.toggle('showMenu');
  }

  toggleSubMenu(submenu) {
    submenu.visible = true;
    this.firstSidebarMenus
      .filter(item => item.id !== submenu.id)
      .forEach(item => (item.visible = false));

    this.selectedFirstMenu = this.sidebarService.secondSidebarMenus
      .filter(menu => {
        if (menu.name === 'Textbook') {
          return !!submenu.textbook && submenu.haveSubMenu;
        }
        return true;
      })
      .map(menu => {
        if (menu.path) {
          menu.path.splice(1, 1, submenu.id);
        }
        if (menu.onClick) {
          menu.onClick = () =>
            this.sidebarService.textbookSubject.next(submenu.textbook ? submenu.textbook.url : '');
        }
        return menu;
      });
  }

  toggleSubmenuItem(item) {
    item.visible = !item.visible;
    this.gameListSidebarMenus
      .filter(menuItem => menuItem !== item)
      .forEach(menuItem => (menuItem.visible = false));
  }

  ngOnDestroy() {
    if (this.simulationSubscription) {
      this.simulationSubscription.unsubscribe();
    }
    this.simulationService.cleanup();
  }

  // Expose simulation validation methods to template
  get canSimulate(): boolean {
    return this.simulationService.canSimulate();
  }

  get canRollback(): boolean {
    return this.simulationService.canRollback();
  }
}
